import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DxTabPanelModule, DxValidationSummaryModule, DxValidatorModule } from 'devextreme-angular';
import { DxiToolbarItemModule, DxoToolbarModule } from 'devextreme-angular/ui/nested';
import { SharedModule } from '../../../shared/shared.module';
import { ApproveDenyReasonsModule } from '../agent-editor';
import { ModalWindowModule } from '../modal-window/modal-window.module';
import { AgentDispositionModalControlsPipe } from './agent-disposition-modal-controls.pipe';
import { AgentDispositionModalComponent } from './agent-disposition-modal.component';
import { AgentInfoModalTitlePipe } from './agent-info-modal-title.pipe';
import { PromptModule } from '../prompt/prompt.module';
import { AgencyHierarchyManagementModule } from 'ag-common-svc/lib/modules/agency-hierarchy-administration/agency-hierarchy-management/agency-hierarchy-management.module';
import { AgentTeamTransferElasticSearchService } from 'ag-common-svc/lib/services/elastic-search.services/agent-team-transfer-elastic-search.service';
import { BatchOperationsService } from 'ag-common-svc/lib/dao/batch-firestore.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ModalWindowModule,
    DxiToolbarItemModule,
    DxTabPanelModule,
    ApproveDenyReasonsModule,
    PromptModule,
    AgencyHierarchyManagementModule,
    DxValidatorModule,
    DxValidationSummaryModule,
  ],
  declarations: [AgentDispositionModalComponent, AgentDispositionModalControlsPipe, AgentInfoModalTitlePipe],
  exports: [AgentDispositionModalComponent],
  providers: [AgentTeamTransferElasticSearchService, BatchOperationsService],
})
export class AgentDispositionModalModule {}
